import { createMutation } from 'react-query-kit';
import { type AxiosRequestConfig } from 'axios';

import { AI_HTTP_CLIENT } from './client';

export type UseGetPresetPromptsForSimilarQuizRequest = {
  locale: string;
  question: string;
  category?: string;
};

type UseGetPresetPromptsForSimilarQuizResponse = {
  prompts: string[];
};

const createGetPresetPromptsForSimilarQuizMutation = () =>
  createMutation<
    UseGetPresetPromptsForSimilarQuizResponse,
    UseGetPresetPromptsForSimilarQuizRequest
  >({
    mutationFn: ({ locale, question, category }) => {
      return AI_HTTP_CLIENT.post<UseGetPresetPromptsForSimilarQuizResponse>(
        '/quiz-builder/generate/get-similar-quiz-prompt',
        {
          locale,
          question,
          category,
        },
        {
          headers: {
            ...AI_HTTP_CLIENT.defaults.headers,
            'Content-Type': 'application/json',
          } as AxiosRequestConfig['headers'],
        },
      ).then(res => ({
        prompts: res.data.prompts,
      }));
    },
  });

export const useGetPresetPromptsForSimilarQuiz =
  createGetPresetPromptsForSimilarQuizMutation();
